import React, {useState} from 'react';
import K from '../../k';
import Tag from './tag';

const CheckableTag = ({color = K.colors.gray, checked, onChange, children, style}) => {
  //HINT determines whether or not component should be managed locally.
  //     When isChecked is true, behavior is only driven by props.
  const isControlled = typeof checked === 'boolean';
  const [isChecked, setIsChecked] = isControlled ? [checked, null] : useState(false);

  const handleClick = () => {
    if (!isControlled) setIsChecked(!isChecked);

    if (onChange) onChange(!checked);
  };

  return (
    <Tag
      {...{color: isChecked ? color : '#F5F5F5', onChange, children, style}}
      onClick={handleClick}
    >
      {children}
    </Tag>
  );
};

export default CheckableTag;